import axios from "./axiosConfig";

const dashboardService = {
  getKpis() {
    return axios.get("/dashboard/kpis");
  },
  getServicesByMonth() {
    return axios.get("/dashboard/services-by-month");
  },
  getServicesByTechnician(year, month) {
    return axios.get("/dashboard/services-by-technician", {
      params: { year, month },
    });
  },
  getServicesByType() {
    return axios.get("/dashboard/services-by-type");
  },
  getServicesByTechnicianAndType(year, month) {
    return axios.get("/dashboard/services-by-technician-and-type", {
      params: { year, month },
    });
  },
  getExecutiveOverview() {
    return axios.get("/dashboard/executive");
  },
};

export default dashboardService;
